export function LoaderBounce() {
  return (
    <div className="flex items-center gap-2">
      <div className="w-2 h-2 bg-[#EF0BB8] rounded-full animate-bounce [animation-delay:-0.3s]"></div>
      <div className="w-2 h-2 bg-[#EF0BB8] rounded-full animate-bounce [animation-delay:-0.15s]"></div>
      <div className="w-2 h-2 bg-[#EF0BB8] rounded-full animate-bounce"></div>
    </div>
  );
}
